import { Table, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import {
  STATEMENT_MAIN_BODY,
  STATEMENT_SUB_TITLE,
} from '../../../../constants/printoutConstants';
import {
  StatementPrintoutTableData,
  StatementPrintoutOrderData,
} from '../../../../types';
import getDashboardStyle from '../../../../utils/getDashboardStyle';
import { ColumnsType } from 'antd/lib/table';

type StatementPrintoutTableProps = {
  data: StatementPrintoutOrderData;
};

const StatementPrintoutTable = ({ data }: StatementPrintoutTableProps) => {
  const { t } = useTranslation();
  const columns: ColumnsType<StatementPrintoutTableData> = [
    {
      title: t('order.printoutComponents.date'),
      key: 'date',
      dataIndex: 'date',
      width: 150,
      align: 'center',
      render: (text: any, record: StatementPrintoutTableData) => (
        <Typography.Text
          style={{ paddingLeft: 5, fontSize: STATEMENT_MAIN_BODY }}
        >
          {getDashboardStyle().isWholeSaleAppType
            ? record.orderShipping &&
              record.orderShipping.formattedExpectShippingTime
              ? record.orderShipping.formattedExpectShippingTime
              : record.date
            : record.date}
        </Typography.Text>
      ),
    },
    {
      title: t('order.printoutComponents.invoiceId'),
      align: 'center',
      key: 'serialNumber',
      dataIndex: 'serialNumber',
      width: 150,
      render: (text: any, record: StatementPrintoutTableData) => (
        <Typography.Text
          style={{ paddingLeft: 5, fontSize: STATEMENT_MAIN_BODY }}
        >
          {record.serialNumber}
        </Typography.Text>
      ),
    },
    {
      title: t('order.printoutComponents.invoiceAmount'),
      align: 'center',
      key: 'orderAmount',
      dataIndex: 'orderAmount',
      width: 150,
      render: (text: any, record: StatementPrintoutTableData) => (
        <Typography.Text
          style={{ paddingLeft: 5, fontSize: STATEMENT_MAIN_BODY }}
        >
          {record.isCreditMemo ? '-' + record.orderAmount : record.orderAmount}
        </Typography.Text>
      ),
    },
    {
      title: t('order.printoutComponents.openAmount'),
      align: 'center',
      key: 'amount',
      dataIndex: 'amount',
      width: 150,
      render: (text: any, record: StatementPrintoutTableData) => (
        <Typography.Text
          style={{ paddingLeft: 5, fontSize: STATEMENT_MAIN_BODY }}
        >
          {record.isCreditMemo
            ? record.amount !== '0'
              ? '-' + record.amount
              : '/'
            : record.amount}
        </Typography.Text>
      ),
    },
  ];

  return (
    <Table
      style={{ width: 575 }}
      className="tablePrintout statementPrintoutTable"
      dataSource={data.statementOrders}
      rowKey={(data, index) => `${index}`}
      columns={columns}
      pagination={false}
      size="small"
      bordered={true}
      summary={() => (
        <>
          <Table.Summary.Row>
            <Table.Summary.Cell index={0} align="center">
              <Typography.Text
                style={{ fontSize: STATEMENT_MAIN_BODY }}
              >
                {t('order.printoutComponents.summaryAmount')}
              </Typography.Text>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={1} />
            <Table.Summary.Cell index={2} align="center">
              <Typography.Text
                strong
                style={{ fontSize: STATEMENT_MAIN_BODY }}
              >
                {data.originalStatementAmount}
              </Typography.Text>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={3} align="center">
              <Typography.Text
                strong
                style={{ fontSize: STATEMENT_MAIN_BODY }}
              >
                {data.totalStatementAmount}
              </Typography.Text>
            </Table.Summary.Cell>
          </Table.Summary.Row>
          <Table.Summary.Row>
            <Table.Summary.Cell index={0} colSpan={4}>
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'space-between',
                  padding: '0 8px',
                  boxSizing: 'border-box',
                }}
              >
                <Typography.Text strong style={{ fontSize: STATEMENT_SUB_TITLE }}>
                  {t('order.printoutComponents.amountDue')}
                </Typography.Text>
                <Typography.Text strong style={{ fontSize: STATEMENT_MAIN_BODY }}>
                  {data.totalStatementAmount}
                </Typography.Text>
              </div>
            </Table.Summary.Cell>
          </Table.Summary.Row>
        </>
      )}
    />
  );
};

export default StatementPrintoutTable;
